import { ITag } from "../../interfaces/ITag";

export function parseArticleTags(tags?: string): ITag[] {
	return (
		tags?.split(",").map((tag, index) => {
			return {
				id: index,
				name: tag.trim(),
				visible: 1
			} as ITag;
		}) || []
	);
}
